// Required fields for each POI type
export const REQUIRED_FIELDS = {
  Road: ['roadType', 'measurements'],
  Intersection: ['intersectionType', 'trafficControl', 'measurements'],
  Bridge: ['bridgeType', 'structureNumber', 'measurements'],
  PowerLine: ['lineType', 'supportType', 'measurements'],
  Trees: ['treeType', 'measurements'],
  Signalization: ['signalizationType', 'measurements'],
  Railroad: ['crossingType', 'crossingNumber', 'measurements'],
  Custom: ['customName', 'measurements']
};

// Touch level definitions with colors and hover/selected states
export const TOUCH_LEVELS = [
  { 
    value: 0, 
    label: 'Not Touched', 
    color: 'bg-green-500 text-white',
    selectedColor: 'bg-green-600 text-white ring-2 ring-green-400 ring-offset-2 ring-offset-[#2A2B2E]'
  },
  { 
    value: 3, 
    label: '0" to 3"', 
    color: 'bg-yellow-500 text-white',
    selectedColor: 'bg-yellow-600 text-white ring-2 ring-yellow-400 ring-offset-2 ring-offset-[#2A2B2E]'
  },
  { 
    value: 6, 
    label: '3" to 6"', 
    color: 'bg-orange-500 text-white',
    selectedColor: 'bg-orange-600 text-white ring-2 ring-orange-400 ring-offset-2 ring-offset-[#2A2B2E]'
  },
  { 
    value: 12, 
    label: '6" to 12"', 
    color: 'bg-red-500 text-white',
    selectedColor: 'bg-red-600 text-white ring-2 ring-red-400 ring-offset-2 ring-offset-[#2A2B2E]'
  },
  { 
    value: 13, 
    label: 'Over 12"', 
    color: 'bg-black text-white border-2 border-red-500',
    selectedColor: 'bg-black text-white border-2 border-red-500 ring-2 ring-red-400 ring-offset-2 ring-offset-[#2A2B2E]'
  }
];

export const MEASUREMENT_TYPES = {
  TOUCH: 'touch',
  CUSTOM: 'custom'
};